import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
export default function dateTypeListOptions() {
    
	const dateTypeOptions = [{
        id: 'today',
        text: 'Today'
    }, {
        id: 'yesterday',
        text: 'Yesterday'
    }, {
        id: 'last7days',
        text: 'Last 7 Days'
    }, {
        id: 'lastweek',
        text: 'Last Week'
    }, {
        id: 'thismonth',
        text: 'This Month'
    }, {
        id: 'last30days',
        text: 'Last 30 Days'
    }, {
        id: 'lastmonth',
        text: 'Last Month'
    }, {
        id: 'last90days',
        text: 'Last 90 Days'
    }, {
        id: 'custom_date',
        text: 'Custom Date'
    }, {
        id: 'all_time',
        text: 'All Time'
    }];

    return {
        dateTypeOptions
    }
}